'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var jurisdictions_constants = require('../jurisdictions.constants.js');
var getAmlStatus = require('@gig/magic-sdk/dist/adapter/users/getAmlStatus');

function getGracePeriodDaysLeft(periods) {
    var DAY = 24 * 60 * 60 * 1000;
    var earliestDate = periods.reduce(function (lowest, _a) {
        var endDate = _a.endDate;
        var endTime = new Date(endDate + 'Z').getTime();
        if (!lowest) {
            return endTime;
        }
        return endTime < lowest ? endTime : lowest;
    }, null);
    return earliestDate
        ? Math.max(0, Math.ceil((earliestDate - Date.now()) / DAY))
        : 0;
}
function isKYCRequestedByAML(status) {
    var statuses = [
        getAmlStatus.AmlStatus.PENDING,
        getAmlStatus.AmlStatus.PROCESSING,
        getAmlStatus.AmlStatus.REJECTED,
    ];
    return statuses.includes(status.SOWD) || statuses.includes(status.SOWQ);
}
/**
 * Logic to figure out if the link to withdraw page should be displayed
 * in the sow countdown modal.
 *
 * If UKGC and grace period is expired, then display the link
 * @param jurisdiction User jurisdiction
 * @param daysLeft Countdown days left
 */
function shouldDisplayLinkToWithdraw(jurisdiction, daysLeft) {
    if (daysLeft > 0) {
        return false;
    }
    return (jurisdiction === jurisdictions_constants.Jurisdiction.UKGC || jurisdiction === jurisdictions_constants.Jurisdiction.SGA);
}

exports.getGracePeriodDaysLeft = getGracePeriodDaysLeft;
exports.isKYCRequestedByAML = isKYCRequestedByAML;
exports.shouldDisplayLinkToWithdraw = shouldDisplayLinkToWithdraw;
